import {
  isAnalyticsDebugEnabled,
  persistAnalyticsDebugLocalFromEnv,
} from "./analyticsEnvironment";
/**
 * Dev-only markers for DebugView opt-in (localStorage + console checks).
 * GA4 debug traffic uses `debug_mode: true` in `initializeAnalytics` config
 * (`firebaseAnalyticsInstance.js`), not this global — Firebase Web SDK v10+
 * does not read `FIREBASE_ANALYTICS_DEBUG_MODE`.
 * @see https://firebase.google.com/docs/analytics/debugview
 */
export function applyFirebaseAnalyticsDebugGlobal() {
  if (!isAnalyticsDebugEnabled()) return;
  persistAnalyticsDebugLocalFromEnv();
  try {
    // eslint-disable-next-line no-underscore-dangle
    globalThis.FIREBASE_ANALYTICS_DEBUG_MODE = true;
  } catch {
    /* unavailable */
  }
}
